<template>
  <div v-if="popUpIsActive" class="popup-overlay" @click.self="close">
    <div class="popup-content">
      <div class="popup-header">
        <button class="popup-close" @click="close">✕</button>
      </div>
      <div class="popup-textbox">
        <h2>⚠️ Sorry for the Inconvenience</h2>
        <p>
          MDL will be under maintenance from
          <strong>10:00 PM to 6:00 AM</strong>.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Popup',
  props: {
    popUpIsActive: {
      type: Boolean,
    },
    onClosePopUp: {
      type: Function,
    },
  },
  methods: {
    close() {
      this.onClosePopUp();
    },
  },
};
</script>
<style scoped lang="scss">
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1000;
}

.popup-content {
  position: relative; /* สำคัญ */
  background: #fff;
  padding: 24px 24px 20px;
  border-radius: 8px;

  width: 100%;
  max-width: 420px; /* desktop */
  max-height: 90vh; /* กันล้นจอ */
  overflow-y: auto; /* scroll ถ้าเนื้อหาเยอะ */
  box-sizing: border-box;
}
.popup-header {
  //   border: 1px solid;
  padding: 10px 0px 5px 0px;
}

/* กากบาท */
.popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.popup-close:hover {
  opacity: 0.7;
}

.popup-textbox {
  margin-right: 10px;
  //   border: 1px solid;
}
</style>
